<mat-toolbar class="menu mat-elevation-z3">
  <button (click)="toggleSideMenu()" class="menu__open-sidebar" mat-icon-button aria-label="Open sidebar menu">
    <mat-icon>menu</mat-icon>
  </button>
  <div class="menu__logo">
    <a routerLink="homeLink"><img src="/assets/images/gd-logo.png" alt="App logo" /></a>
  </div>
  <p class="menu__title">IP Rights Timesheets</p>
  <ng-container *ngIf="emailFromToken; else noToken">
    <div class="user__data user__data--with-margin">
      <h4 class="user__email">{{ emailFromToken }}</h4>
    </div>
  </ng-container>
  <ng-template #noToken>
    <div class="user" *ngIf="user; else noUser">
      <img [src]="user.photoUrl" class="mat-icon user__photo" />
      <div class="user__data">
        <h3 class="user__name">{{ user.fullName }}</h3>
        <h4 class="user__email">{{ user.email }}</h4>
      </div>
    </div>
    <ng-template #noUser>
      <div class="user">
        <mat-icon class="user__icon">face</mat-icon>
        <div class="user__data">
          <h3 class="user__name">Name Surname</h3>
          <h4 class="user__email">n.surname@griddynamics.com</h4>
        </div>
      </div>
    </ng-template>
  </ng-template>

  <button (click)="onSignOut()" mat-flat-button [disableRipple]="true" class="menu__logout">
    <mat-icon svgIcon="logout"></mat-icon>
    LOG OUT
  </button>
</mat-toolbar>
